// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__TmvAT","heroBody":"Hero_heroBody__sUK0V"};